import "./style.scss";
import PhoneInput from "react-phone-input-2";
import FormControl from "../../../../components/common/FormControl";
import Layout from "../../../../components/global/layout";
import methodModel from "../../../../methods/methods";
import { FiPlus } from "react-icons/fi";
import { IoCloseOutline } from "react-icons/io5";
import SelectDropdown from "../../../../components/common/SelectDropdown";

const Html = ({
  handleSubmit,
  setForm,
  form,
  submitted,
  handleChangePhone,
  goBack,
  ImageUpload
}) => {
  return (
    <>
      <Layout>
        <div className="wrapper_section py-6 lg:py-16">
          <div className="w-12/12 md:w-8/12 px-4  lg:w-6/12 xl:w-5/12 mx-auto">
            <div className="flex items-center justify-between">
              <h3 className="text-2xl font-semibold text-[#111827]">
                Edit Profile
              </h3>
            </div>
            <form name="" autoComplete="one-time-code" onSubmit={handleSubmit}>
              <div className="shadow p-6 mt-6 rounded-xl w-full gap-4 bg-white">
                <div className="flex flex-col gap-4">
                  <div className="">
                    <FormControl
                      type="text"
                      label="First Name"
                      value={form?.firstName}
                      onChange={(e) => setForm({ ...form, firstName: e })}
                      required
                    />
                  </div>
                  <div className="col-span-12 md:col-span-6">
                    <FormControl
                      type="text"
                      label="Last Name"
                      value={form?.lastName}
                      onChange={(e) => setForm({ ...form, lastName: e })}
                      required
                    />
                  </div>
                  <div className="col-span-12 md:col-span-6">
                    <label>Mobile number <span className="text-red-500">*</span> </label>
                    <PhoneInput
                      placeholder="Mobile Number"
                      className="mobile-input"
                      country={"us"}
                      value={form?.mobileNo ? form?.dialCode + form?.mobileNo : null}
                      enableSearch={true}
                      inputProps={{ required: true, autoComplete: "one-time-code" }}
                      onChange={(phone, country) =>
                        handleChangePhone(phone, country)
                      }
                    />
                    {submitted && !form?.mobileNo && (
                      <div className="invalid-feedback d-block">
                        Mobile Number is required
                      </div>
                    )}
                  </div>
                  <div className="col-span-12 md:col-span-6">
                    <label>Email  <span className="text-red-500">*</span></label>
                    <input
                      type="email"
                      className="relative shadow bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-2"
                      value={form.email}
                      autoComplete="false"
                      readOnly
                    />
                  </div>
                  <div className="col-span-12 md:col-span-6">
                    <div className="mb-3">
                      <label className="lablefontcls">Image</label>
                      <div className="flex flex-col rounded-lg cursor-pointer gap-6 max-sm:mx-auto">
                        {form?.image ? (
                          <>
                            <span className="inline-flex">
                              <div className="relative mt-2">
                                <img src={methodModel.userImg(form?.image)} className="rounded-full h-20 w-20 block" />
                                <IoCloseOutline className="absolute top-0 -right-5 pointer hover:text-red-600" onClick={e => setForm({ ...form, image: "" })} size={25} />
                              </div>
                            </span>
                          </>
                        ) : (
                          <label className={`flex items-center justify-center cursor-pointer text-black-800 bg-[#fff] focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 border-2 border-dashed border-gray-200 w-full`} style={{ gap: '8px' }}>
                            <FiPlus />
                            <input
                              id="dropzone-file"
                              type="file"
                              className="hidden"
                              onChange={ImageUpload}
                            />
                            Upload Image
                          </label>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-span-12 md:col-span-6">
                    <label>Allow the SMS updates</label>
                    <SelectDropdown
                      id="statusDropdown"
                      displayValue="name"
                      className="mt-1 capitalize mb-8"
                      placeholder="Select Event"
                      theme="search"
                      intialValue={form?.isTwillio}
                      result={(e) => setForm((prev) => ({ ...prev, isTwillio: e.value }))}
                      isClearable={false}
                      options={[
                        { id: true, name: "Yes" },
                        { id: false, name: "No" },
                      ]}
                    />
                  </div>
                </div>
                <div className="text-right mt-3">
                  <button type="button" onClick={() => { goBack() }} className="text-white bg-gray-400 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-3">
                    Cancel
                  </button>
                  <button className="text-white bg-[#F58D18] focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center">
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Html;